import { BulbIcon } from '../icons';
import { LabelBody } from './LabelBody';
import { LabelBodySmall } from './LabelBodySmall';

type Props = {
    title?: string;
    children: string;
    className?: string;
};
export function Tip({ title = 'Tip!', children, ...props }: Props) {
    return (
        <div {...props}>
            <div className="flex flex-row">
                <BulbIcon className="mr-10" />
                <LabelBodySmall>{title}</LabelBodySmall>
            </div>
            <LabelBody class="mt-10">{children}</LabelBody>
        </div>
    );
}
